module.exports = __webpack_public_path__ + "img/11step-02-05-1_ergebnis.92294b08.png";